import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import Link from '@mui/material/Link';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import {withStyles} from '@mui/styles';
import PropTypes from 'prop-types';
import React from 'react';
import {connect} from 'react-redux';
import {getFormValues, reduxForm} from 'redux-form';
import MainContainer from '../../organisms/MainContainer.js';
import getMenuItems from '../../organisms/MenuItem/MenuItems.js';
import withRouter from '../../organisms/withRouter.js';
import Dashboard from './Dashboard/index.js';
import {postRequest} from '../../../common/backend.js';
import {renderNoticeArea} from '../../atoms/CustomPart.js';
import {authOperations} from '../../../reducks/auth/index.js';
import {HttpStatusCode} from 'axios';

const styles = (theme) => ({
  root: {
    flexDirection: 'column',
  },
  menuContainer: {
    width: '95%',
    borderCollapse: 'collapse',
    backgroundColor: '#4F89C6',
    color: '#fff',
    textAlign: 'left',
    border: '1px solid black',
    marginTop: '10px',
    marginBottom: '10px',
  },
  menuItemL1empty: {
    backgroundColor: '#4F89C6',
    width: '10px',
    padding: 0,
    border: '1px solid #4F89C6',
  },
  menuItemL1: {
    backgroundColor: '#4F89C6',
    color: '#fff',
    textAlign: 'left',
    fontSize: '1.4em',
    border: 'none',
    padding: '8px',
  },
  menuItemL2empty: {
    backgroundColor: 'rgb(175, 171, 171)',
    width: '10px',
    padding: 0,
    border: 'none',
  },
  menuItemL2: {
    backgroundColor: 'rgb(175, 171, 171)',
    color: '#fff',
    textAlign: 'left',
    fontSize: '1.0em',
    border: 'none',
    padding: '8px',
  },
  menuItemL3: {
    backgroundColor: 'rgb(255, 255, 255)',
    color: 'black',
    textAlign: 'left',
    fontSize: '1.0em',
    height: '20px',
    padding: 0,
    border: '1px solid rgb(175, 171, 171)',
  },
  menuButton: {
    width: '100%',
    textAlign: 'left',
    color: 'black',
  },
  imgLogo: {
    marginTop: '10px',
    marginLeft: '75px',
  },
  copyrightMenu: {
    textAlign: 'right',
    display: 'block',
    position: 'absolute',
    color: 'white',
    right: '4px',
    bottom: '4px',
  },
  messageArea: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    marginBottom: 12,
  },
  helpDeskArea: {
    height: 'auto',
    width: 'auto',
    border: '1px solid red',
    background: 'white',
    padding: 10,
  },
  noticeArea: {
    height: '420px',
    margin: '0 0 0 auto',
    marginBottom: 10,
    textAlign: 'left',
    fontSize: '1.016em',
    borderRadius: '3px',
    border: '3px solid #4F89C6',
    background: 'white',
    padding: '4px 10px',
    overflowX: 'none',
    overflowY: 'scroll',
    userSelect: 'auto',
  },
  noticeTitle: {
    margin: '0 0 0 auto',
    textAlign: 'center',
    fontSize: '1.4em',
    fontWeight: 'bold',
  },
  noticeRed: {
    color: 'red',
  },
});

/**
 * メニュー画面 テンプレート。
 * 画面ID:1000/2000
 */
class Container extends React.Component {
  /**
   * コンストラクタ。
   * @param {object} props プロパティ
   */
  constructor(props) {
    super(props);

    this.state = {
      information: '',
      roleMenuItems: [],
    };
  }

  /**
   * 初期処理
   */
  async componentDidMount() {
    const {getRoleMenuItems} = this.props;
    // 権限マスタからメニュー項目を取得
    const roleMenuItems = await getRoleMenuItems(true);

    // ログインのインフォメーション取得
    const information = await this.doGetInformation();
    let infoItem = information?.systemSettingsList[0]?.valueString;
    this.setState({
      information: infoItem || '',
      roleMenuItems: roleMenuItems,
    });
  };

  /**
   * インフォメーションを取得する
   * @return {Promise<Object>} 検索結果
   */
  doGetInformation = async () => {
    const body = {
      condition: {
        classification: ['2'],
        itemName: 'メニュー',
      },
    };
    const response = await postRequest('common/get-information', body);
    if (response.status != HttpStatusCode.Ok) {
      return null;
    }
    return response.data;
  };

  /**
   * GRID単位(1列に入る項目)の要素生成。
   * @param {JSX.Element} children GRID内の要素
   * @return {JSX.Element} GRID単位の要素
   */
  rendarGrid = (children) => {
    console.dir(children);
    return (
      <Grid item xs={4}>
        {children}
      </Grid>
    );
  };

  /**
   * 大項目単位の要素生成。
   * @param {MajorItem} item 大項目単位のメニュー項目
   * @param {number} index インデックス
   * @return {JSX.Element} 大項目単位の要素
   */
  renderTableMajorItem = (item, index) => {
    const {classes} = this.props;
    const element = [];

    element.push(
        <TableRow key={'MJ_' + index}>
          <TableCell colSpan="2" className={classes.menuItemL1}>{item.name}</TableCell>
        </TableRow>,
    );

    const middleItems = item.items;
    for (let i = 0; i < middleItems.length; i++) {
      element.push(this.renderTableMinorItem(middleItems[i], i, index));
    }

    return (
      <TableContainer
        component={Paper}
        className={classes.menuContainer}
      >
        <Table>
          <TableBody>
            {element}
          </TableBody>
        </Table>
      </TableContainer>
    );
  };

  /**
   * 小項目単位の要素生成。
   * @param {MinorItem} item 小項目単位のメニュー項目
   * @param {number} index インデックス
   * @param {number} majorIndex 大項目単位のインデックス
   * @return {JSX.Element} 小項目単位の要素
   */
  renderTableMinorItem = (item, index, majorIndex) => {
    const {classes, navigate} = this.props;
    const element = [];

    element.push(
        <TableRow key={'MN_' + index}>
          <TableCell className={classes.menuItemL1empty}></TableCell>
          <TableCell className={classes.menuItemL3}>

            <Button
              componet={Link}
              onClick={() => {
                // // ストアに開いているメニュー項目のnodeIdを保持
                this.props.setExpandedMenuItems(Array.of(majorIndex + ''));
                navigate(item.path, {});
              }}
              startIcon={<ArrowRightIcon />}
              className={classes.menuButton}
              disabled={!item.path}
            >
              <u className={classes.menuButton}>{item.name}</u>
            </Button>
          </TableCell>
        </TableRow>,
    );

    return element;
  };

  /**
   * メニュー描画
   * @param {MajorItem[]} majorItems
   * @return {JSX.Element} テーブルの要素
   */
  renderTable = (majorItems) => {
    const {classes} = this.props;
    let columnTables = [];
    const columns = [];

    for (let i = 0; i < majorItems.length; i++) {
      const majorItem = majorItems[i];
      columnTables.push(this.renderTableMajorItem(majorItem, i));
      let isLastLine = false;
      if (i >= majorItems.length - 1) isLastLine = true;

      // 大項目4個毎に縦に並べる
      if (i % 4 == 3 || isLastLine) {
        columns.push(this.rendarGrid(columnTables));
        columnTables = [];
      }
    }

    const isVisible = false; // TODO Ⅰ期不表示
    return (
      <Box>
        <Grid container spacing={0}>
          {columns}
          <Grid item xs={4}>
            <div className={classes.noticeTitle}>お知らせ</div>
            {renderNoticeArea(classes.noticeArea, this.state.information)}

            {isVisible &&
            <>
              <div className={classes.noticeTitle}>未処理件数</div>
              <div style={{marginTop: '15px', marginRight: '-15px'}}>
                <Grid item xs={12}>
                  <Dashboard/>
                </Grid>
              </div>
            </>
            }
          </Grid>
        </Grid>
      </Box>
    );
  };

  /**
   * 描画処理。
   * @return {JSX.Element} メニュー画面の要素
   */
  render() {
    const {classes, userInfo} = this.props;

    // メニュー項目を取得
    const rows = getMenuItems(userInfo, this.state.roleMenuItems);

    return (
      <form noValidate autoComplete="off" className={classes.root}>
        <MainContainer props={this.props} disableSideMenu={true}
          bgImg={false}>
          {this.renderTable(rows)}
        </MainContainer>
      </form>
    );
  }
}

Container.propTypes = {
  classes: PropTypes.object.isRequired,
  userInfo: PropTypes.object.isRequired,
  navigate: PropTypes.func,
  getRoleMenuItems: PropTypes.func.isRequired,
  setExpandedMenuItems: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
});

const mapDispatchToProps = {
  getRoleMenuItems: authOperations.doGetMenuItemsOperation,
  setExpandedMenuItems: authOperations.doSetExpandedMenuItems,
};

const FORM_NAME = 'Menu';

Container = reduxForm({
  form: FORM_NAME,
  destroyOnUnmount: false,
  enableReinitialize: true,
})(connect((state) => {
  return {
    values: getFormValues(FORM_NAME)(state),
  };
})(Container));

export default withStyles(styles)(
    connect(
        mapStateToProps,
        mapDispatchToProps,
    )(withRouter(Container)),
);
